<template>
    <div>
        <gmap-map :center="center"
            :zoom="17"
            style="width: 100%; height: 100%;">
            <GmapCustomMarker :marker="center" :zIndex="0">
            <img :src="markerIcon" class="marker-icon"/>
            </GmapCustomMarker>
        </gmap-map>
    </div>
</template>

<script>
import GmapCustomMarker from 'vue2-gmap-custom-marker'
export default {
    name: 'GoogleMaps',
    components: { GmapCustomMarker },
    data () {
        return {
            center: { lat: 37.5571838, lng: 126.8639604 },
            markers: [],
            places: [],
            currentPlace: null,
            markerIcon: require('../../assets/image/about/marker_icon.png')
        }
    },
    methods: {
        setPlace (place) {
            this.currentPlace = place
        },
        addMarker () {
            if (this.currentPlace) {
                const marker = {
                    lat: this.currentPlace.geometry.location.lat(),
                    lng: this.currentPlace.geometry.location.lng()
                }
                this.markers.push({ position: marker })
                this.places.push(this.currentPlace)
                this.center = marker
                this.currentPlace = null
            }
        },
        geolocate: function () {
            navigator.geolocation.getCurrentPosition(position => {
                this.center = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                }
            })
        }
    },
    mounted () {
        this.geolocate()
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/mixin.scss';
@include over-desktop {
    .marker-icon {
        transform: scale(0.85);
        transform-origin: bottom center;
    }
}
@include under-tablet {
    .marker-icon {
        transform: scale(0.5);
        transform-origin: bottom center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/about/GoogleMaps.vue